import {connect} from "react-redux";

const React = require('react');

class UserHomePage extends React.Component {
    render() {

        const username = this.props.user.firstName + " " + this.props.user.lastName;
        const email = this.props.user.email;
        const department = this.props.user.department ? this.props.user.department.name : null;
        const canApprove = this.props.user.isInApprovalFlow;
        const canAddPapers = department !== null;
        const companyName = this.props.user.companyName;

        const items = [
            {label: 'Institutie', value: companyName},
            {label: 'Nume', value: username},
            {label: 'Email', value: email},
            department && {label: 'Compartiment', value: department},
            {label: 'Drept de aprobare', value: canApprove ? 'DA' : 'NU'},
            {label: 'Poate adauga referate', value: canAddPapers ? 'DA' : 'NU'}
        ].filter(Boolean);

        return (
            <div className="ds-home">
                <div className="ds-home-hero">
                    <h1>Bine ati venit!</h1>
                    <p>Platforma de achizitii publice a institutiei dumneavoastra.</p>
                </div>

                <div className="ds-home-grid">
                    {items.map(item => (
                        <div className="ds-home-item" key={item.label}>
                            <small>{item.label}</small>
                            <strong>{item.value}</strong>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.login.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(UserHomePage)
